import { render } from "./purchaselistView.vue?vue&type=template&id=b17030e4&scoped=true"
import script from "./purchaselistView.vue?vue&type=script&lang=js"
export * from "./purchaselistView.vue?vue&type=script&lang=js"

import "./purchaselistView.vue?vue&type=style&index=0&id=b17030e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b17030e4"]])

export default __exports__